import styled from 'styled-components';

export const BusinessNeedsMainWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background-color: ${props.theme.colors.blue.blueBg};
        border: 1px solid rgba(0, 140, 255, 0.22);
        box-shadow: 0 4px 8px 0 rgba(138, 107, 18, 0.08);
        padding: ${props.theme.spacing.large.l30} 0;


        @media only screen and (min-width:320px) and (max-width: 991px){
            padding: ${props.theme.spacing.large.l25} ${props.theme.spacing.small.s8} ${props.theme.spacing.small.s5};
        }
    `
);

export const BusinessNeedsInnerWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        max-width:85%;
        margin:0 auto;
        flex-direction: column;

        @media only screen and (min-width:320px) and (max-width: 991px){
            max-width: 100%;
        }
    `
)

export const BusinessNeedHeadWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-bottom: ${props.theme.spacing.large.l30};

        @media only screen and (min-width:320px) and (max-width: 991px){
            padding-bottom: ${props.theme.spacing.large.l15};
        }
    `
);

export const BusinessNeedsHeadText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font35};
        color: ${props.theme.colors.black.base1};
        font-weight: ${props.theme.font.fontWeight.black};
        line-height: ${props.theme.font.lineHeight.small};
        letter-spacing: -1px;

        @media only screen and (min-width:320px) and (max-width: 991px){
            font-size: ${props.theme.font.large.font18};
        }
    `
);

export const BuinessInfoCardWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: ${props.theme.spacing.small.s5};

        @media only screen and (min-width:320px) and (max-width: 991px){
            flex-direction: column;;
        }
    `
);

export const BusinessInfoCard = styled.div(
    props => `
        width:48%;
        display: flex;
        background-color: ${props.theme.colors.white.base};
        border-radius: 0.8rem;
        box-shadow: 0px 3px 6px 0px rgba(0,0,0,0.15);
        margin-right: ${props.theme.spacing.base};
        height:11.2rem;
        align-items: center;
        justidy-content: space-between;

        @media only screen and (min-width:320px) and (max-width: 991px){
            width:100%;
            margin-bottom: ${props.theme.spacing.large.l20};
            margin-right: 0;
            height: 7.9rem;
        }
    `
);


export const BusinessInfoCardImgWrap = styled.div(
    props => `
        width:13rem;
        height: 11.2rem;
        border-radius: 8px 0 0 8px;
        position: relative;

        @media only screen and (min-width:320px) and (max-width: 991px){
            height: 7.9rem;
            width: 8.5rem;
        }
    `
);

export const BusinessInfoTypeTag = styled.div(
    props => `
        display: flex;
        align-self: center;
        padding: ${props.theme.spacing.small.s6} ${props.theme.spacing.base};
        border-radius: 2rem;
        background-image: linear-gradient(71deg, #f5515f, #9f0469);
        position: absolute;
        top: -1.5rem;
        left:50%;
        transform: translateX(-50%);

        @media only screen and (min-width:320px) and (max-width: 991px){
            padding: ${props.theme.spacing.small.s3} ${props.theme.spacing.small.s8};
            top: -0.8rem;
        }
    `
);

export const BusinessInfoTypeText = styled.p(
    props => `
        font-size: ${props.theme.font.base};
        color: ${props.theme.colors.white.base};
        font-weight: ${props.theme.font.fontWeight.bold};
        text-transform:uppercase;

        @media only screen and (min-width:320px) and (max-width: 991px){
            font-size: ${props.theme.font.small.font8};
            font-weight: normal;
        }
    `
)

export const BusinessInfoImg = styled.img(
    props=> `
        width:100%;
        display: flex;
        height: 100%;
        border-radius: 8px 0 0 8px;
    `
);

export const BusinessInfoTextWrap = styled.div(
    props => `
        width:70%;
        display: flex;
        flex-direction: column;
        padding: ${props.theme.spacing.large.l20};
        height:100%;
        justify-content: space-between;

        @media only screen and (min-width:320px) and (max-width: 991px){
            padding: ${props.theme.spacing.base};
        }
    `
);

export const BusinessInfoText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font16};
        color: ${props.theme.colors.grey.base};
        font-weight: ${props.theme.font.fontWeight.bold};
        display: flex;
        align-items: center;
        
        span{
            width:8px;
            height: 8px;
            display: inline-flex;
            border-radius: 38px;
            background-image: linear-gradient(45deg, #f5515f, #9f0469);
            margin-right: ${props.theme.spacing.base};
            margin-top:3px;
        }

        @media only screen and (min-width:320px) and (max-width: 991px){
            font-size: ${props.theme.font.base};
        }
    `
)







